export class LoggedUserModel {
  userId!: string;
  userName!: string;
  userRoleName!: string;
  userProfileName!: string;
  userSessionId!: string;
}
